import { convertTimeZone } from '@/commonFunctions/utils'
import { EventsIconRounded } from '@/components/icons'
import { ROUTE_CLUBS, ROUTE_EVENTS } from '@/constants/Routes'
import { Event } from '@/types'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

type Props = {
  event: Event
  onOpenConfirmModal?: (id: number) => void
  className?: string
  showDeleteEvent?: boolean
}

export const EventItem = ({ event, onOpenConfirmModal, className, showDeleteEvent }: Props) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const eventStart =
    event?.duration?.[0] && !event?.startDate
      ? convertTimeZone(event.duration[0])
      : event?.startDate && new Date(event?.startDate)

  const eventEnd =
    event?.duration?.[1] && !event?.endDate
      ? convertTimeZone(event.duration[1])
      : event?.endDate && new Date(event?.endDate)

  const eventStartString = eventStart ? `${moment(eventStart).format('MMM DD')}` : 'Unknown Start Date'

  const eventEndString = eventEnd ? `${moment(eventEnd).format('MMM DD, YYYY')}` : 'Unknown End Date'

  const onNavigateEventDetail = (eventId: number, status: string) => {
    if (status === 'DRAFT') {
      navigate(`${ROUTE_CLUBS}/${event.clubId}/event/${eventId}/edit-draft`)
    } else {
      navigate(`${ROUTE_EVENTS}/${eventId}`)
    }
  }

  return (
    <div
      className={`bg-white rounded-2xl px-4 py-3 flex gap-x-2 cursor-pointer ${className}`}
      key={event.leagueId}
      onClick={() => onNavigateEventDetail(event.leagueId, event.displayStatus)}
    >
      {event?.mediaUrl ? (
        <img src={event?.mediaUrl} className="w-10 h-10 rounded-full" alt="" />
      ) : (
        <EventsIconRounded className="w-10 h-10 text-primary-500" />
      )}
      <div className="flex w-full justify-between">
        <div className="flex flex-col gap-y-1">
          {event?.startDate && (
            <p className="text-navy-900 text-xs font-medium text-opacity-60">
              {`${eventStartString} - ${eventEndString}`}
            </p>
          )}
          <p className="text-navy-900 text-sm font-semibold">{event?.leagueName}</p>
          {event.shortAddress && <p className="text-navy-900 text-opacity-80 text-sm">{event?.shortAddress}</p>}
        </div>

        <div className="flex flex-col justify-center gap-y-2">
          {/* <div
            className={`${BgColor(
              event?.displayStatus
            )} bg-opacity-20 px-2 py-[2px] flex items-center justify-center rounded-lg`}
          >
            <p className={`${ContentColor(event?.displayStatus)} font-medium text-xs`}>
              {EventStatusCase(event?.displayStatus, t)}
            </p>
          </div> */}
          {showDeleteEvent && onOpenConfirmModal && (
            <>
              <button
                className="border hidden sm:flex items-center justify-center rounded text-navy-900 font-semibold text-xs px-4 py-[6px] hover:bg-slate-200"
                onClick={(e) => {
                  e.stopPropagation()
                  onOpenConfirmModal(event.leagueId)
                }}
              >
                {t('common.deleteEvent')}
              </button>

              <button
                className="border flex sm:hidden items-center justify-center rounded text-navy-900 font-semibold text-xs px-4 py-[6px] hover:bg-slate-200"
                onClick={(e) => {
                  e.stopPropagation()
                  onOpenConfirmModal(event.leagueId)
                }}
              >
                {t('common.delete')}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
